export default {
  confirmBtnText: "确 定",
  cancelBtnText: "取 消",
  selectedText: "已选",
  allText: "全部",
  selectTipText: "请选择",
  inputPlaceholder: "请输入",
  goSelectText: "去选择",
  overMessage: "最多只能选择",
  leastMessage: "最少选择",
  funtype: {
    defaultTitle: "选择职能",
    customEmptyText: "暂无匹配职能，选择所属分类",
    emptyText: "暂无匹配职能，换个职位试试",
    cateDialogTitle: "请选择分类",
    cateDialogSubtitleL: "请选择",
    cateDialogSubtitleR: "所属分类，获得更好的推荐"
  },
  expectedCity: {
    defaultTitle: "选择意向城市",
    locationCityText: "当前定位城市",
    hotCityTitleText: "热门城市",
    quanguoTitleText: "全国",
    gangaotaiTitleText: "港澳台",
    guowaiTitleText: "国外",
    yixianCityTitleText: "一线/新一线",
    erxianCityTitleText: "二线城市",
  },
  graduatesDialog: {
    majordefaultTitle: "选择专业",
    certificationdefaultTitle: "选择证书",
    it_skilldefaultTitle: "选择技能/语言",
    industrydefaultTitle: "选择行业",
    emptyText: "未搜索到结果",
  },
  livingArea: {
    'title': '选择现居地'
  }
};
